import { render, staticRenderFns } from "./ScormElement.vue?vue&type=template&id=9a0f394c&scoped=true&"
import script from "./ScormElement.vue?vue&type=script&lang=ts&"
export * from "./ScormElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0f394c",
  null
  
)

export default component.exports